module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Revealer",
    class: _vm.elClass
  }, [_c('div', {
    staticClass: "Revealer-content"
  }, [_c('div', {
    staticClass: "Revealer-image",
    on: {
      "click": function($event) {
        _vm.isRevealed = !_vm.isRevealed
      }
    }
  }, [(!_vm.disabled) ? _c('expander', {
    staticClass: "Revealer-expander",
    attrs: {
      "active": _vm.isRevealed
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "Revealer-imageImage",
    attrs: {
      "src": _vm.image
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Revealer-text"
  }, [(_vm.content.title1 || _vm.content.description1) ? _c('div', {
    staticClass: "Revealer-textItem"
  }, [(_vm.content.title1) ? _c('p', {
    staticClass: "Revealer-textItemHeader t-headingXs",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.description1) ? _c('p', {
    staticClass: "Revealer-textItemBody t-xSmall",
    domProps: {
      "innerHTML": _vm._s(_vm.content.description1)
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.content.title2 || _vm.content.description2) ? _c('div', {
    staticClass: "Revealer-textItem"
  }, [(_vm.content.title2) ? _c('p', {
    staticClass: "Revealer-textItemHeader t-headingXs",
    domProps: {
      "innerHTML": _vm._s(_vm.content.title2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.description2) ? _c('p', {
    staticClass: "Revealer-textItemBody t-xSmall",
    domProps: {
      "innerHTML": _vm._s(_vm.content.description2)
    }
  }) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25dcc27f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Learn/Revealer.vue
// module id = 818
// module chunks = 1